import { render, staticRenderFns } from "./CamposDescricao.vue?vue&type=template&id=c5cadc86&scoped=true&"
import script from "./CamposDescricao.vue?vue&type=script&lang=js&"
export * from "./CamposDescricao.vue?vue&type=script&lang=js&"
import style0 from "./CamposDescricao.vue?vue&type=style&index=0&id=c5cadc86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cadc86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VForm,VRow})
